import { DE_LOCALE } from '@core/Constants/Locale.constants';
import { getFormattedCurrency } from '@core/Utils/Intl/GetFormattedCurrency';
import { DefaultMapKeys, Typography } from '@gds/Typography/Typography';
import { ScrollToFinance } from '@shared-components/ScrollToFinance/ScrollToFinance';

import { VehicleAttributesProps } from '../VehicleAttributes.entity';

import styles from './FinancingDetails.module.css';

type FinancingDetailsProps = Pick<
  VehicleAttributesProps,
  'isStockUnavailable' | 'strings' | 'locale' | 'vehicle' | 'pageType' | 'index'
> & {
  isFinanceFirst?: boolean;
  isScrolling?: boolean;
  hasDiscount: boolean;
};

export const FinancingDetails = ({
  isStockUnavailable,
  strings,
  locale,
  vehicle,
  pageType,
  index,
  isFinanceFirst = false,
  isScrolling,
  hasDiscount,
}: FinancingDetailsProps) => {
  const financeRate = vehicle.finance?.rate;
  const financeProduct = vehicle.finance?.product;
  const isDe = locale === DE_LOCALE;

  let variant = 'buttonLink1';

  if (isFinanceFirst) {
    if ((!hasDiscount && !isScrolling) || hasDiscount) {
      variant = 'h3';
    }
    if (isScrolling && !hasDiscount) {
      variant = 'h5';
    }
  }
  const formattedMonthlyPrice = isDe
    ? `${getFormattedCurrency(financeRate!, locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} `
    : getFormattedCurrency(Math.ceil(financeRate!), locale);

  const fincalcCta = (
    <Typography Component="span" variant={variant as DefaultMapKeys}>
      {!isDe && strings.orPay} {formattedMonthlyPrice}
      {strings.financePriceLabel}{' '}
      {locale === 'uk' && <span className={styles.financeType}>{financeProduct}</span>}
    </Typography>
  );

  if (isStockUnavailable) {
    return fincalcCta;
  }

  return (
    <>
      {isDe && <Typography variant="caption1">{strings.zB}</Typography>}
      <ScrollToFinance string={fincalcCta} pageType={pageType} index={index} />
    </>
  );
};
